<script setup lang="ts">
import { computed, ref, watch, defineEmits, nextTick, onMounted } from 'vue';
 import Codemirror from "codemirror-editor-vue3";

 import "codemirror/lib/codemirror.css";
 import "codemirror/theme/idea.css";
 import "codemirror/mode/sql/sql.js";
 import "codemirror/addon/hint/show-hint.css";
 import "codemirror/addon/hint/show-hint";
 import "codemirror/addon/hint/sql-hint";
 import "codemirror/addon/display/placeholder.js";
 import "codemirror/addon/display/autorefresh";

const props = defineProps({
  modelValue: { type:String, default:''},
})
const _data = ref(props.modelValue)
const _cmOptions = ref({
    mode: "text/x-sparksql",
    theme: "idea",
    smartIndent: true,
    autofocus: true,
    autoRefresh:true,
    lineNumbers:false,
    lineWrapping:true,
    matchBrackets : true,
    tabsize:4,
    // readOnly:false,
    placeholder:'',
    extraKeys: {
        "Tab": "autocomplete", // tab键自动补全
    },    
    hintOptions:{
        completeSingle:false
    }
})
const onkeyup = (cm, event)=>{
  console.log('onkeyup',cm, event)
    if(!event) return
    if (event.keyCode >= 65 && event.keyCode <= 90){
        cm.showHint();
    }
}
const onUpdateVal = ()=>{
  emit('update:modelValue', _data.value) 
}
const codemirrorRef = ref<any>()
onMounted(()=>{
  if(codemirrorRef.value?.cminstance){
    codemirrorRef.value.cminstance.on('keyup', onkeyup); 
  }  
})
const refresh = ()=>{
    if(codemirrorRef.value?.refresh){
        codemirrorRef.value.refresh()  
    }
}

const emit = defineEmits(['update:modelValue']);
watch(()=>props.modelValue, (val:any) => {
  try{
    _data.value = val
  }catch(error){}
}, {immediate: true})
defineExpose({ refresh })
</script>
<template>
  <Codemirror
    v-model:value="_data"
    :options="_cmOptions"
    @change="onUpdateVal"
    ref="codemirrorRef"
    border placeholder="" :height="100"
  />
</template>

<style lang="less" scoped>
</style>